// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';

import { iconUri } from '@nerdwallet/nw-client-lib/cdn';

const SplashFeatureBarItem = ({ name, description, iconUri: uri }) => (
  <Box className="feature">
    <Box className="feature-icon-wrapper">
      <Image
        className="feature-icon"
        backgroundColor="transparent"
        src={iconUri(uri)}
        alt={name}
      />
    </Box>
    <Box className="feature-title">{name}</Box>
    <Box className="feature-description">{description}</Box>
  </Box>
);

SplashFeatureBarItem.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  iconUri: PropTypes.string,
};

SplashFeatureBarItem.defaultProps = {
  name: 'Feature',
  description: 'This is such a great feature!',
  iconUri: 'iPad_graph',
};

export default SplashFeatureBarItem;
